import { Injectable } from '@angular/core';
import { Observable, lastValueFrom } from 'rxjs';
import { TREND_GRAPH_MAX_CHANNELS } from 'ops/common/validators/trend-graph/trend-graph-view-validator';
import { TrendGraphViewsApiService } from './trend-graph-views-api.service';
import { TrendGraphView } from 'ops/common/models/trend-graph-view';

@Injectable({ providedIn: 'root' })
export class TrendGraphViewsService {
    private COLOR_OPTIONS = [
        '#fc78a8',
        '#a29bfe',
        '#6c5de7',
        '#4fa8de',
        '#57cee1',
        '#56ebc1',
        '#fc78a8',
        '#a29bfe',
        '#6c5de7',
        '#4fa8de',
        '#57cee1',
        '#fc78a8',
        '#a29bfe',
        '#6c5de7',
        '#4fa8de',
        '#57cee1',
    ];

    constructor(
        private api: TrendGraphViewsApiService,
    ) {}

    public getAll(): Observable<TrendGraphView[]> {
        return this.api.getAll();
    }

    public async save(view: TrendGraphView): Promise<string> {
        return lastValueFrom(this.api.save(view));
    }

    public async update(view: TrendGraphView): Promise<string> {
        return lastValueFrom(this.api.update(view));
    }

    public async delete(viewId: string): Promise<string> {
        return lastValueFrom(this.api.delete(viewId));
    }

    public getDefaultColors() {
        return this.COLOR_OPTIONS;
    }

    public getNextcolor(view: TrendGraphView) {
        return view.channels.length < TREND_GRAPH_MAX_CHANNELS
            ? this.COLOR_OPTIONS[view.channels.length]
            : this.COLOR_OPTIONS[0];
    }
}
